module.exports = __webpack_public_path__ + "static/media/0029_IMG_LES_MURS_HARMONIE_1.d471e450.png";